const tags = ["负面合集", "黑料汇总", "争议事件", "爆料总集"];

export default function HeroLead() {
  return (
    <section className="relative flex min-h-[560px] w-full flex-col items-center justify-center overflow-hidden md:min-h-[600px]">
      <img
        src="https://readdy.ai/api/search-image?query=Panoramic%20editorial%20collage%20illustration%2C%20layered%20newspaper%20clipping%20fragments%20and%20bold%20magazine%20typography%20blocks%20over%20a%20warm%20cream%20backdrop%2C%20vermillion%20orange%20red%20and%20muted%20teal%20accents%2C%20textured%20paper%20grain%2C%20dynamic%20diagonal%20composition%2C%20abstract%20not%20photographic%2C%20modern%20newsroom%20aesthetic%2C%20high%20detail&width=1920&height=900&seq=hero-hub-x1&orientation=landscape"
        alt="51嘿料负面合集总集封面背景"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-foreground-950/60"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/30 to-transparent"></div>

      <div className="relative z-10 flex w-full max-w-shell flex-col items-center justify-center px-4 py-14 text-center md:px-6 md:py-20">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full bg-background-50/15 px-3 py-1 text-xs font-medium text-background-50 ring-1 ring-background-50/30 backdrop-blur">
          <span className="relative flex h-1.5 w-1.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-300 opacity-75"></span>
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-accent-300"></span>
          </span>
          总集专题 · 本周风向持续更新中
        </span>

        <p className="font-heading mb-3 text-xs tracking-[0.4em] text-background-100/80 md:text-sm">
          51HILIAO · ONE-STOP NEGATIVE ARCHIVE
        </p>

        <h1 className="max-w-4xl text-3xl font-black leading-snug text-background-50 md:text-5xl md:leading-snug">
          51嘿料 争议事件全收录
          <br className="hidden md:block" />
          <span className="text-accent-300">按主题整理</span> 的负面清单与爆料脉络
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          集中浏览 51嘿料黑料汇总、不良记录与近期争议，从热搜到社区评论区，一键定位事件来龙去脉。
          不用四处翻帖，这里一站掌握关键信息与最新风向。
        </p>

        <div className="mt-7 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#hot-board"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400 sm:w-auto"
          >
            <i className="ri-fire-fill mr-2 text-lg" aria-hidden="true"></i>
            查看实时热议榜
          </a>
          <a
            href="#spotlight"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-background-50/15 px-6 py-3 text-sm font-semibold text-background-50 ring-1 ring-background-50/40 backdrop-blur transition-colors hover:bg-background-50/25 sm:w-auto"
          >
            <i className="ri-stack-line mr-2 text-lg" aria-hidden="true"></i>
            浏览分类归档
          </a>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          {tags.map((t) => (
            <span
              key={t}
              className="rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs text-background-100 backdrop-blur"
            >
              #{t}
            </span>
          ))}
        </div>
      </div>

      <div className="absolute bottom-4 left-1/2 z-10 -translate-x-1/2 text-background-50/70">
        <i className="ri-arrow-down-line animate-bounce text-lg" aria-hidden="true"></i>
      </div>
    </section>
  );
}